import { BLOCK } from "../../../types";
import { StructureBrush } from "../brush";
import type { StructureBuilder } from "../types";

export const buildCabin: StructureBuilder = (world, spot) => {
    const brush = new StructureBrush(world, spot);
    const width = 7;
    const depth = 5;
    const wallHeight = 3;

    brush.perimeter(
        0,
        width - 1,
        0,
        wallHeight - 1,
        0,
        depth - 1,
        BLOCK.StructureLog,
        (x, y, z) => !(y < 2 && x === 3 && z === 0),
    );
    brush.layer(-1, width, 0, depth - 1, wallHeight, BLOCK.Thatch);
    brush.layer(0, width - 1, 1, depth - 2, wallHeight + 1, BLOCK.Thatch);
    brush.lineX(0, width - 1, wallHeight + 2, 2, BLOCK.StructureLog);
    brush.column(width - 2, 1, wallHeight + 1, wallHeight + 3, BLOCK.Stone);
};
